var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"b-appointment-info"},[_c('div',{staticClass:"h-flex h-flex-space-between h-align-items-center"},[_c('router-link',{attrs:{"to":"/appointment/matmut/fetch-details"}},[_c('img',{attrs:{"src":_vm.requireImage(`${_vm.mainLogo}.svg`)}})])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }